import { render, staticRenderFns } from "./myAssignment.vue?vue&type=template&id=5ba4ef99&scoped=true&"
import script from "./myAssignment.vue?vue&type=script&lang=js&"
export * from "./myAssignment.vue?vue&type=script&lang=js&"
import style0 from "./myAssignment.vue?vue&type=style&index=0&id=5ba4ef99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4ef99",
  null
  
)

export default component.exports